import { render, staticRenderFns } from "./CvcForm.vue?vue&type=template&id=48453d9d"
import script from "./CvcForm.vue?vue&type=script&lang=js"
export * from "./CvcForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports